
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/question/bank",
      function () {
        return require("private-next-pages/student/question/bank.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/question/bank"])
      });
    }
  